var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CalculatedHeaderBox"},[_c('div',{staticClass:"footerHeader"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/ceyiceicon.png"),"alt":""}}),_c('p',{staticClass:"titleText"},[_vm._v("\n      额度测算中...\n    ")]),_c('p',{staticClass:"text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }